import { Anchor } from 'antd';
import React from 'react';
import { MOBILE_HEADER_HEIGHT_APPROX } from '../../components/header/header_mobile';
import useDynamicRefs from '../../hooks/use_dynamic_refs';
import { useResponsive } from '../../hooks/use_responsive';
import styles from './product_detail_nav.less';
import { PdpIds } from './product_detail_page';

interface ProductDetailNavProps {
  fishingReportsCount: number;
  complementaryProductFamiliesCount: number;
  relatedProductFamiliesCount: number;
  mediaCount: number;
}

export const ProductDetailNav = (props: ProductDetailNavProps) => {
  const {
    fishingReportsCount,
    complementaryProductFamiliesCount,
    relatedProductFamiliesCount,
    mediaCount,
  } = props;
  const { getRef, setRef } = useDynamicRefs();
  const { isMobile } = useResponsive();

  return (
    <div>
      <Anchor
        affix={true}
        key={`${fishingReportsCount} ${complementaryProductFamiliesCount} ${relatedProductFamiliesCount}`}
        targetOffset={200}
        className={styles.anchor}
        showInkInFixed={false}
        offsetTop={isMobile ? MOBILE_HEADER_HEIGHT_APPROX : 0}
        onChange={(currentActiveLink) => {
          if (currentActiveLink) {
            const spanRef = getRef<HTMLSpanElement>(currentActiveLink.replace('#', ''));
            const wrapper = getRef<any>('wrapper')?.current;
            if (wrapper && spanRef) {
              wrapper.scrollTo({
                left: spanRef.current.getBoundingClientRect().left + wrapper.scrollLeft - 18,
                behavior: 'smooth',
              });
            }
          }
        }}
      >
        <ul className={styles.navContainer} ref={setRef('wrapper')}>
          <li>
            <Anchor.Link
              href={`#${PdpIds.description}`}
              title={<span ref={setRef(PdpIds.description)}>Description</span>}
            />
          </li>

          <li>
            <Anchor.Link
              href={`#${PdpIds.all_variations}`}
              title={<span ref={setRef(PdpIds.all_variations)}>All Variations</span>}
            />
          </li>

          {complementaryProductFamiliesCount > 0 && (
            <li>
              <Anchor.Link
                href={`#${PdpIds.complementary}`}
                title={<span ref={setRef(PdpIds.complementary)}>Complementary</span>}
              />
            </li>
          )}

          {relatedProductFamiliesCount > 0 && (
            <li>
              <Anchor.Link
                href={`#${PdpIds.related}`}
                title={<span ref={setRef(PdpIds.related)}>Related</span>}
              />
            </li>
          )}

          {fishingReportsCount > 0 && (
            <li>
              <Anchor.Link
                href={`#${PdpIds.fishing_reports}`}
                title={
                  <span ref={setRef(PdpIds.fishing_reports)}>
                    Fishing Reports ({fishingReportsCount})
                  </span>
                }
              />
            </li>
          )}

          {mediaCount > 0 && (
            <li>
              <Anchor.Link
                href={`#${PdpIds.media}`}
                title={<span ref={setRef(PdpIds.media)}>Videos & Articles ({mediaCount})</span>}
              />
            </li>
          )}
        </ul>
      </Anchor>
    </div>
  );
};
